import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { X, SignalHigh } from "lucide-react";

const rel = (iso) => {
  if (!iso) return "jamais";
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 60) return `il y a ${Math.floor(s)}s`;
  if (s < 3600) return `il y a ${Math.floor(s / 60)} min`;
  if (s < 86400) return `il y a ${Math.floor(s / 3600)} h`;
  return `il y a ${Math.floor(s / 86400)} j`;
};
const abs = (iso) => (iso ? new Date(iso).toLocaleString("fr-FR", { timeZone: "Pacific/Noumea", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—");

export default function DevicesStatusModal({ onClose }) {
  const [data, setData] = useState(null);
  const load = useCallback(() => api.get("/devices/status").then((r) => setData(r.data)).catch(() => {}), []);
  useEffect(() => { load(); const t = setInterval(load, 5000); return () => clearInterval(t); }, [load]);
  const devices = data?.devices || [];

  return (
    <div className="fixed inset-0 z-[2200] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4" onClick={onClose} data-testid="devices-status-modal">
      <div className="glass rounded-lg w-full max-w-lg max-h-[80vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between p-4 border-b border-border">
          <div>
            <p className="font-bold text-base flex items-center gap-2"><SignalHigh className="w-4 h-4 brand-teal" /> Balises connectées</p>
            <p className="text-[11px] text-muted-foreground mt-0.5">{data ? `${data.connected_count} connectée(s) en TCP · ${devices.length} unité(s) · maj auto 5s` : "Chargement…"}</p>
          </div>
          <button onClick={onClose} data-testid="devices-status-close" className="text-muted-foreground hover:text-foreground"><X className="w-4 h-4" /></button>
        </div>
        <div className="overflow-y-auto divide-y divide-border/60">
          {devices.map((d) => {
            const state = d.tcp_connected ? { c: "#10B981", l: "Connectée (TCP)" } : d.recent ? { c: "#F59E0B", l: "Données récentes" } : { c: "#71717A", l: "Hors ligne" };
            return (
              <div key={d.imei || d.name} className="flex items-center gap-3 px-4 py-2.5" data-testid={`device-status-${d.imei}`}>
                <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ background: state.c, boxShadow: `0 0 8px ${state.c}` }} />
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-semibold truncate flex items-center gap-1.5">{d.name}{d.provisional && <span className="text-[8px] font-bold uppercase px-1 py-0.5 rounded bg-[#F5821F]/20 text-[#F5821F]">à config.</span>}</p>
                  <p className="data text-[11px] text-muted-foreground">IMEI {d.imei || "—"}</p>
                </div>
                <div className="text-right shrink-0">
                  <p className="text-[11px] font-medium" style={{ color: state.c }}>{state.l}</p>
                  <p className="data text-[10px] text-muted-foreground" title={abs(d.last_seen)}>{rel(d.last_seen)}</p>
                </div>
              </div>
            );
          })}
          {data && devices.length === 0 && <p className="text-center text-xs text-muted-foreground py-8">Aucune balise enregistrée</p>}
        </div>
      </div>
    </div>
  );
}
